import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { collection, getDocs, } from "firebase/firestore";

import { db } from '../../firebase'
import { Link } from "react-router-dom";


import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'



import {
  FacebookShareButton, WhatsappShareButton, WhatsappIcon,
  FacebookIcon, TwitterShareButton, EmailShareButton, EmailIcon,

  LinkedinShareButton,
  LinkedinIcon,
  TwitterIcon,
} from "react-share";

function DoogdryAdult() {
  // Sample product images by size
  const sizeImages = {
    "90gm": "https://i.postimg.cc/qMVP0sCB/Adult-Chicken-Vegetables-Sachet-Pouch-90g-FOP.png",
    "370gm": "https://i.postimg.cc/ncXJcF3T/Adult-chicken-Vegetable-Sachet-Pouch-370g-FOP.png",
    "1kg": "https://i.postimg.cc/Y2gPXvD5/Adult-chicken-Vegetable-Sachet-Pouch-1-kg-FOP.png",
    "2.8kg": "https://i.postimg.cc/nLyk7kxC/Adult-chicken-Vegetable-Sachet-Pouch-2-8-kg-FOP.png",
    "5.5kg": "https://i.postimg.cc/65tgSB9J/Pedigree-Puppy-Chicken-Milk-5-5-kg.png",
    "10kg": "https://i.postimg.cc/CxNPs3ym/Adult-chicken-Vegetable-10kg-FOP.png",
    "15kg": "https://i.postimg.cc/7Y1mqFLw/10257079-product-image-3-0.jpg",
    "20kg": "https://i.postimg.cc/Hsm9v69K/Adult-chicken-Vegetable-15-Kg-FOP-0.png",

  };

  const [selectedSize, setSelectedSize] = useState("90gm"); // default size





  const phoneNumber = "918927119640"; // Replace with your number (with country code, no +)
  const message = "Hello..";

  const encodedMessage = encodeURIComponent(message);
  const whatsappURL = `https://wa.me/${918927119640}?text=${encodedMessage}`;



  return (


    <>





      <br />





      <div className="album py-1">

        <div className="container">

          <div className="row">




            <div className="col-md-12 mt-3">
              <div className="card mb-4">
                <h4 className='btn-grad87'>PEDIGREE® Chicken and Vegetables for Adult Dogs</h4>

                <img
                  src={sizeImages[selectedSize]}
                  alt={`Product ${selectedSize}`}
                  className="w-64 h-64 object-cover border rounded-xl shadow-md"
                />

                <div className="flex gap-3 mt-3">
                  {Object.keys(sizeImages).map((size) => (
                    <button
                      key={size}
                      onClick={() => setSelectedSize(size)}
                      className={`px-4 py-2 border rounded-lg text-lg font-medium
              ${selectedSize === size ? "bg-primary text-white" : "bg-white text-black"}
            `}
                    >
                      {size}
                    </button>
                  ))}
                </div>
                <div className="card-body">

                  <h6 className="card-text"> <b>Pedigree Dry Range</b></h6>

                  <p className="card-text mb-2"><small> Chicken &amp; Milk for Puppy is a wholesome meal, packed with essential nutrients vital to the healthy growth of your pet.</small></p>
                  <p style={{ color: "Gray" }} className="card-text mb-2">Starting M.R.P.: <del> ₹25</del> </p>
                  <button className='btn btn-outline-danger btn-sm mb-2'>16 %OFF</button>
                  <p><b>Flat 18% off on 15 kg and 20 kg R bags.</b></p>
                  <h6 className="card-text" >₹ 90GM -21/-, 370GM -84/-, 1KG -225/-, 2.8KG- 550/-, 5.5KG -1167/-, 10KG -2007/-, 15KG -2788/-, 20KG -3197/- </h6>
                  <p className="card-text mb-0">free home delivery</p>
                  <div className="d-flex justify-content-between align-items-center">

                    <a href='tel: 8927119640'> <p className="healthpetproducts mt-2">Call Book</p></a>
                    <a href={whatsappURL} target="_blank" rel="noopener noreferrer">
                      <button style={{ padding: "4px 12px", backgroundColor: "#1B8755", color: "white", border: "none", borderRadius: "5px", cursor: "pointer" }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" fill="currentColor" class="bi bi-whatsapp" viewBox="0 0 16 16">
                          <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232" />
                        </svg>
                      </button>
                    </a>          </div>
                  <button type="button" className="btn btn btn-dark me-1">
                    Share  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-share-fill" viewBox="0 0 16 16">
                      <path d="M11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.499 2.499 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5z" />
                    </svg>
                  </button> < FacebookShareButton url="https://www.petplazza.com/healthessentials" className="me-2 mt-2" quote={"M B Dhar and Son Jewellers"} hastag={"#WebApp"}
                  >
                    <FacebookIcon size={37} round={true} />
                  </FacebookShareButton>

                  <  WhatsappShareButton url="https://www.petplazza.com/healthessentials" className="me-2 mt-2" quote={"M B Dhar and Son Jewellers"} hastag={"#WebApp"}
                  >
                    <WhatsappIcon size={37} round={true} />
                  </ WhatsappShareButton>

                  <  TwitterShareButton url="https://www.petplazza.com/ring" className="me-2 mt-2" quote={"M B Dhar and Son Jewellers"} hastag={"#WebApp"}
                  >
                    <TwitterIcon size={37} round={true} />
                  </ TwitterShareButton>

                  <  LinkedinShareButton url="https://www.petplazza.com/ring" className="me-2 mt-2" quote={"M B Dhar and Son Jewellers"} hastag={"#WebApp"}
                  >
                    <  LinkedinIcon size={37} round={true} />
                  </ LinkedinShareButton>

                  <  EmailShareButton url="https://www.petplazza.com/ring" className="mt-2" quote={"M B Dhar and Son Jewellers"} hastag={"#WebApp"}
                  >
                    <  EmailIcon size={37} round={true} />
                  </ EmailShareButton>
                  <div className="d-flex justify-content-between align-items-center">



                  </div>
                </div>
              </div>

            </div>

          </div>

        </div>
      </div>

    </>

  );
}

export default DoogdryAdult;